/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'log-out': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M16 18H7a2 2 0 01-2-2v-4h2v4h9V2H7v4H5V2a2 2 0 012-2h9a2 2 0 012 2v14a2 2 0 01-2 2zm-7-5v-3H0V8h9V5l5 4-5 4z" _fill="#646769"/>'
  }
})
